<template>
    <div>
            <NuxtPage />
            <LazyDialogsToast ref="toast" />
    </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "authentication",
});
</script>

<style scoped>

</style>